<div style="padding-bottom: 10px">
  View all resources of the type defined in all Resource Type Definitions (RTDs)
  in the selected managed service.
</div>
<div [ngClass]="'table-scroll'">
  @if (rtdResourcesStateMessage) {
    <fd-message-strip
      class="infoStateNotReady"
      type="information"
      [dismissible]="false"
      >{{ notReadyMessage }}</fd-message-strip
    >
  }
  <ng-template #cantAccess>
    @if (!errorDetails && hasPrivilegesPermissions) {
      <app-cant-access-path class="cantAccessButton"> </app-cant-access-path>
    }
  </ng-template>

  @if (!errorDetails) {
    <app-details-table-header
      (doResetFilter)="reset()"
      [additionalRightContent]="cantAccess"
      class="header-container-rtd"
      (doSearch)="doSearch($event)"
      [disableClearFilter]="!dataTableComponent?.hasFilter"
    ></app-details-table-header>
  }

  @if (errorDetails) {
    <app-error-strip
      [popup]="false"
      i18n="
        XMSG|An error that is displayed when failed to retrieve resource
        details@@contentDetails.errors.retrievalFailed"
      errorText="Could not fetch the existing RTD type resource for this managed service; please try again later."
      [errorMsg]="errorDetails"
    >
      <a
        href="#"
        (click)="toggleDetails($event)"
        style="color: #fff; text-decoration: underline; margin-left: 10px"
      >
        {{ showDetails ? "Hide Details" : "View Details" }}
      </a>
      @if (showDetails) {
        <div style="margin-top: 10px; color: #fff">
          {{ errorDetails }}
        </div>
      }
    </app-error-strip>
  }

  <app-data-table
    #dataTable
    id="rtd-type-resources-table"
    class="table-scroll"
    [loading]="loading"
    [pagination]="rtdResources?.length > 0 ? pagination : undefined"
    [dataset]="rtdResources"
    [stickyHeaders]="true"
    [filterPipe]="filterPipe"
    [filterPipeArgs]="[searchTerm, 'path', 'name', 'type']"
    noDataFilteredMessage="No results match your search query"
    [noDataMessage]="
      !errorDetails
        ? 'There are no resources for the type defined in the RTDs of this managed service.'
        : ''
    "
    sortProperty="path"
  >
    <app-column
      [isSortable]="true"
      value="path"
      [isFilterable]="true"
      header="Path"
    >
      <ng-template #tableBodyTemplate let-row="row">
        <div class="link-wrapper">
          <div class="link-title-wrapper">
            <a
              fd-link
              aria-label="Standard"
              class="resource-title"
              [title]="row.path"
              (click)="onNavigateToPathPress(row.path)"
              title="Open path in new browser tab"
              [routerLink]=""
              >{{ row.path }}</a
            >
            <button
              fd-button
              fdType="transparent"
              class="link-color"
              title="Open path in new browser tab"
              (click)="onNavigateToPathPress(row.path)"
            >
              <fd-icon font="SAP-icons" glyph="inspect" />
            </button>
            <button
              fd-button
              fdType="transparent"
              class="copy-button link-color"
              title="Copy Path"
              (click)="onCopyPath(row.path)"
            >
              <app-icon icon="copy" size="1x"></app-icon>
            </button>
          </div>
        </div>
      </ng-template>
    </app-column>

    <app-column
      [isSortable]="true"
      [isFilterable]="true"
      value="name"
      header="Name"
    ></app-column>
    <app-column
      [isSortable]="true"
      [isFilterable]="true"
      value="type"
      header="Type"
    ></app-column>

    @if (!errorDetails && !hasPrivilegesPermissions) {
      <ng-template #noDataMessageTemplate>
        <div
          style="
            text-align: center;
            padding: 80px;
            border-radius: 8px;
            margin-bottom: 15%;
          "
        >
          <p style="margin-bottom: 20px">
            To show the resources of the type defined in the RTDs in the managed
            service, we need to grant you read permission
            <br /><br />
            by adding your e-mail as a principal in the managed service.
          </p>
          <button
            style="
              padding: 8px 20px;
              color: white;
              background-color: #007bff;
              border: none;
              border-radius: 4px;
              cursor: pointer;
            "
            (click)="onShowResources()"
          >
            SHOW RESOURCES
          </button>
        </div>
      </ng-template>
    }
  </app-data-table>
</div>
